module.exports = __webpack_public_path__ + "static/media/about-partner-carousel-4.b577a80e.png";